import React from "react";
import { LabelMarkerType, useData } from "../contexts/DataContext";
import RouteColorSwatch from "../../Maps/ActiveRoutes/RouteColorSwatch";
import { normalizeSiteMapColor } from "../utils/colors";
import MapRouteSidebar, { MapRouteDelete } from "../components/MapRouteSidebar";

// this route only is shown / operates in editing mode
const SiteMapTextRoute = ({ text }: { text: LabelMarkerType | undefined }) => {
  return <>{!text ? <NoTextFound /> : <EditTextDetails text={text} />}</>;
};

export default SiteMapTextRoute;

const TextWrapper = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return <MapRouteSidebar title={title}>{children}</MapRouteSidebar>;
};

const NoTextFound = () => {
  return (
    <TextWrapper title="No Text">
      <div style={{ color: "red" }}>No text selected</div>
    </TextWrapper>
  );
};

const EditTextDetails = ({ text }: { text: LabelMarkerType }): JSX.Element => {
  const { deleteLabelMarker, updateLabelMarker } = useData();

  const handleTextColorChange = (color: string) => {
    updateLabelMarker({ ...text, color });
  };

  return (
    <>
      <TextWrapper title="Edit Text">
        <div>
          <div style={{ marginBottom: "10px" }}>
            <label
              htmlFor="color"
              style={{ display: "block", marginBottom: "5px" }}
            >
              Color:
            </label>
            <RouteColorSwatch
              size="lg"
              placement="left"
              color={normalizeSiteMapColor(text.color, "black")}
              onChange={handleTextColorChange}
              testId="text-color-swatch"
            />
          </div>
        </div>
        <MapRouteDelete onDelete={() => deleteLabelMarker(text)} />
      </TextWrapper>
    </>
  );
};
